import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import SmartLink from "../fragments/SmartLink";
import Image from "../fragments/Image";
import { useReveal } from '../hooks/UseReveal';

import "swiper/css";
import "swiper/css/navigation";

import SpecialText from "../fragments/SpecialText";

const normalizeImageSrc = (src) => {
	if (!src) return [];
	if (Array.isArray(src)) return src;
	return Array.from({ length: 9 }, () => src);
};

export default function Instagram({ block }) {

	const swiperRef = useRef(null);
	const revealRef = useReveal({ once: true });

	const items = Array.isArray(block?.data?.data)
		? block.data.data
		: Array.isArray(block?.data)
			? block.data
			: [];

	if (!block || items.length === 0) return null;

	return (
		<div id={block.section_id} className="c-page__block c-page__block--instagram">
			<div className="c-instagram">
				<div className="l-grid c-transition-in" ref={revealRef}>
					<div className="l-grid__col">
						<h2 className="c-instagram__heading c-heading">
							<SpecialText text={block.heading || 'Instagram'} />
						</h2>
					</div>
					<div className="l-grid__col">
						<Swiper
							modules={[Navigation]}
							navigation={true}
							loop={true}
							centeredSlides={true}
							centeredSlidesBounds={true}
							slidesPerView={1.75}
							spaceBetween={16}
							breakpoints={{
								640: {
									slidesPerView: 2.75,
									spaceBetween: 24,
								},
								960: {
									slidesPerView: 3.75,
									spaceBetween: 28,
								},
							}}
							grabCursor={true}
							onSwiper={(s) => (swiperRef.current = s)}
							className="c-instagram__swiper"
						>
							{items.map((item, index) => {
								const isVideo = item.media_type === 'VIDEO';
								const mediaSrc = isVideo ? (item.thumbnail_url || item.media_url) : item.media_url;
								const imageSrc = normalizeImageSrc(mediaSrc);
								const caption = item.caption || '';

								return (
									<SwiperSlide key={item.id || index}>
										<SmartLink link={item.permalink} className="c-instagram__item">
											<div className="c-instagram__media">
												<Image
													src={imageSrc}
													alt={caption}
													width={640}
													height={640}
												/>
												{isVideo && <span className="c-instagram__badge">Video</span>}
											</div>
										</SmartLink>
									</SwiperSlide>
								);
							})}
						</Swiper>
					</div>
				</div>
			</div>
		</div>
	);
} 